import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { API } from '@/api'
import InfoIcon from '@/assets/icons/info.svg?react'
import { Button, message, Modal, Trans } from '@/components'
import { Network } from '@/models/network'
interface ClusterDeleteModalProps {
  network?: Network
  onSuccess: () => void
  onClose: () => void
}

export function ClusterDeleteModal({
  network,
  onSuccess = () => {},
  onClose = () => {},
}: ClusterDeleteModalProps) {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const onOK = useCallback(async () => {
    setLoading(true)
    try {
      const res = await API.deleteMesh({
        res_id: network!.resID,
      })
      if (res.code === 0) {
        message.success(t('common.message.success'))
        onSuccess()
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [network])

  return (
    <Modal
      className="w-[480px]"
      open={true}
      onClose={() => {
        if (!loading) {
          onClose()
        }
      }}
    >
      <Modal.Header>
        <Trans i18nKey="mesh.deleteModal.title">Delete</Trans>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="t-sm text-highlight flex items-center gap-4 bg-blue-50 border-blue-300 rounded-lg p-4 ">
            <InfoIcon className="w-8 h-8" />
            <Trans i18nKey="mesh.deleteModal.warning">
              The network group cannot be released if it contains active instances.
            </Trans>
          </div>
          <div className=" t-medium text-secondary mt-4">
            <Trans i18nKey="mesh.deleteModal.content">
              Are you sure you want to release this network group? Any associated configurations
              will be lost, and this action cannot be undone.
            </Trans>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="outline"
          onClick={() => {
            if (!loading) {
              onClose()
            }
          }}
        >
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        <Button type="danger" disabled={loading} onClick={onOK}>
          <Trans i18nKey="mesh.deleteModal.confirmBtn">Delete</Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
